import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { CloseIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, IconButton } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { useSecretChatRequestPopupPresenter } from './SecretChatRequestPopup.presenter';
import styles from './SecretChatRequestPopup.styles.m.css';

interface ISecretChatRequestPopupProps {
  groupId: string;
}

export const SecretChatRequestPopup: FC<ICommonPopupsProps<ISecretChatRequestPopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useSecretChatRequestPopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened
        isHidden={props.popupInstance.isHidden}
        onClose={presenter.onClose}
        className={styles.popup}
      >
        <div className={styles.wrapper}>
          <IconButton
            className={styles.close}
            Icon={CloseIcon}
            dataTest="close-popup"
            onClick={presenter.onClose}
          />
          <img
            src={getMascotImageSrc('ill-xl-secure.png')}
            className={styles.logo}
            alt={''}
          />
          <h1 className={styles.title}>{t('secure_chat_locked_on_device_title')}</h1>
          <div className={styles.description}>{t('secure_chat_locked_on_device_description')}</div>
          <Button
            size={'20'}
            onClick={presenter.onRequest}
            isLoading={presenter.isLoading}
            theme="primary"
          >
            {t('secure_chat_request_access')}
          </Button>
        </div>
      </Popup>
    );
  });
